import axios, { AxiosResponse } from 'axios';

import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { NewsArticleDetail } from '../apiSchema';

const defaultData: NewsArticleDetail = {
    id: 0,
    title: '',
    description: '',
    featuredImage: '',
    content: null,
    publishedDate: null,
    tags: null,
    tagItems: null
};

async function getNewsArticleDetails(id: number): Promise<NewsArticleDetail> {
    const response: AxiosResponse<NewsArticleDetail> = await axios.get(getApiLink('NewsArticle/GetNewsArticleById', { id }));

    return response.data;
}

export default function useNewsArticleDetails(id: number) {
    return useData(defaultData, getNewsArticleDetails, id);
}
